import { useRef, useState } from "react";
// import "./app.css";
import { Link } from "react-router-dom";

import Pricing from "../components/Pricing";
import logo from "@/assets/talentick.ai.webp";
// import GetInTouch from "@/components/Home/GetInTouch";

import "@/app.css";
// import FAQ from "@/components/Home/FAQ";
// import TrustedUser from "@/components/Home/TrustedUser";
// import logo from "@/assets/talentick.ai.webp";
import HeroSection from "@/components/Home/HeroSection";

import DemoVideo from "@/components/Home/DemoVideo";

import GetInTouch from "@/components/Home/GetInTouch";
import FAQ from "@/components/Home/FAQ";
import RequestDemo from "@/components/Home/RequestDemo";
import WhyChooseUs from "@/components/Home/WhyChooseUs";
import Features from "@/components/Home/Features";
import Footer from "@/components/Home/Footer";
const Home = () => {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const homeRef = useRef<HTMLDivElement>(null);
	const featureRef = useRef<HTMLDivElement>(null);

	const contactRef = useRef<HTMLDivElement>(null);
	const demosRef = useRef<HTMLDivElement>(null);
	const planRef = useRef<HTMLDivElement>(null);

	const closeMenu = () => {
		setMobileMenuOpen(false)
	}

	const handleHomeClick = () => {
		closeMenu()
		if (homeRef.current) {
			homeRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};
	const handleFeatureClick = () => {
		closeMenu()
		if (featureRef.current) {
			featureRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};


	const handlePlansClick = () => {
		closeMenu()
		if (planRef.current) {
			planRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};
	// const handleDemoClick = () => {
	// 	if (demosRef.current) {
	// 		demosRef.current.scrollIntoView({ behavior: "smooth" });
	// 	}
	// };
	const handleContactClick = () => {
		closeMenu()
		if (contactRef.current) {
			contactRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (

		<div className="bg-white overflow-x-hidden">
			{/* Header */}
			<header className="fixed top-5 w-full lg:flex justify-center z-50">

				<div className="w-[90vw] rounded-full py-3 px-6 shadow-sm  border border-gray-200 mx-auto flex justify-between items-center bg-white ">


					{/* Logo */}
					<div className="flex items-center">
						<img src={logo} alt="Bluetick Logo" className="w-32 cursor-pointer" />
					</div>

					{/* Desktop Nav */}
					<nav className="hidden lg:flex items-center space-x-10 ml-10">
						<a onClick={handleHomeClick} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Home</a>
						<a onClick={handleFeatureClick} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Features</a>
						<a onClick={handlePlansClick} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Pricing</a>
					</nav>

					{/* Auth Buttons */}
					<div className="hidden lg:flex items-center gap-4">
						<Link to="/login" className="px-4 py-2 rounded-full border border-[#7EB08A] hover:scale-110 transition-all">Log in</Link>
						<Link to="/register" className="bg-black text-white px-4 py-2 rounded-full border border-[#7EB08A] hover:scale-110 transition-all">Get Started</Link>
					</div>

					{/* Mobile Hamburger */}
					<div className="lg:hidden">
						<button onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
							<svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
							</svg>
						</button>
					</div>
				</div>

				{/* Mobile Menu */}
				{mobileMenuOpen && (
					<div className="lg:hidden flex flex-col w-[90vw]  items-center bg-white shadow px-4 py-4 space-y-4 mx-auto mt-2 rounded-2xl">
						<a onClick={handleHomeClick} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Home</a>
						<a onClick={handleFeatureClick} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Features</a>
						<a onClick={handlePlansClick} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Pricing</a>
						<Link to="/login" className="text-[#7EB08A] border px-4 py-2 rounded-full border-[#7EB08A]">Log in</Link>
						<Link to="/register" className="bg-black text-white px-4 py-2 rounded-full">Get Started</Link>
					</div>
				)}
			</header>

			{/* Page Sections */}
			<section id="home" ref={homeRef}><HeroSection /></section>
			<main className="">

				<div className="flex justify-center md:px-4">
					<div className="w-full max-w-7xl">
						<section id="demo" ref={demosRef} className="mt-20"><DemoVideo /></section>
						<section id="features" ref={featureRef} className="mt-20"><Features /></section>
						<section className="mt-32"><WhyChooseUs /></section>
					</div>
				</div>

				<section id="pricing" ref={planRef} className="mt-20 px-4"><Pricing /></section>
				<section className="mt-20 "><RequestDemo contactUs={handleContactClick} /></section>
				<section className="mt-20 px-4"><FAQ contactUs={handleContactClick} /></section>
				<section ref={contactRef} className="mt-20 px-4"><GetInTouch /></section>
			</main>

			<footer className="mt-20">
				<Footer
					featScroll={handleFeatureClick}
					pricingScroll={handlePlansClick}
					contactScroll={handleContactClick}
				/>
			</footer>
		</div>
	);
};

export default Home;
